import handleMethod from '../Utils/APIutils/handleMethod';

class ClientAPI {
  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/clients/${id}` });
  }

  async list({
    page = 1,
    itemsPerPage = 20,
    isActive,
    startDate,
    endDate,
    sortBy,
    sortDirection,
    planType,
    clientId,
    storeId,
    city,
    status,
  } = {}) {
    const params = new URLSearchParams();

    params.set('page', page);
    params.set('itemsPerPage', itemsPerPage);

    const fmt = (v) => (Array.isArray(v) ? v.filter(Boolean).join(',') : v);

    if (typeof isActive === 'boolean') params.set('isActive', String(isActive));
    if (startDate) params.set('startDate', new Date(startDate).toISOString());
    if (endDate) params.set('endDate', new Date(endDate).toISOString());
    if (sortBy) params.set('sortBy', sortBy);
    if (sortDirection) params.set('sortDirection', sortDirection);
    if (planType && fmt(planType)) params.set('planType', fmt(planType));
    if (clientId && fmt(clientId)) params.set('clientId', fmt(clientId));
    if (storeId && fmt(storeId)) params.set('storeId', fmt(storeId));
    if (city && fmt(city)) params.set('city', fmt(city));
    if (status && fmt(status)) params.set('status', fmt(status));

    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/clients?${params.toString()}`,
    });
  }

  async create(data) {
    return handleMethod({ type: 'POST', method: 'api/gatewaycontagem/clients', params: data });
  }

  async update(id, data) {
    return handleMethod({ type: 'PUT', method: `api/gatewaycontagem/clients/${id}`, params: data });
  }

  async remove(id) {
    return handleMethod({ type: 'DELETE', method: `api/gatewaycontagem/clients/${id}` });
  }

  async regenerateApiKey(id) {
    return handleMethod({ type: 'POST', method: `api/gatewaycontagem/clients/${id}/regenerate-api-key` });
  }
}

export const clientAPI = new ClientAPI();
